<div style="background-color:#fafafa;">
  <router-outlet></router-outlet>
</div>